
export class DigitalFactsheet{
    digitalFactsheetTitle : string;
	digitalFactsheetUrl : string;
	month : string;
	year : string;
    id?:number;
}

export class Year{
    year : string;
}

export class Month{
    month : string;
}